import React from "react";
import { Form, Input } from "antd";

const HiddenItem = ({ fieldName, initialValue, getFieldDecorator }) => (
  <Form.Item>
    {getFieldDecorator(fieldName, {
      ...{ initialValue },
    })(<Input type="hidden" />)}
  </Form.Item>
);

export default HiddenItem;
